import { Box, Grid, Stack, Typography } from "@mui/material";
import ecgWave from "../../../assets/ecg_wave.gif";
import { useEffect, useRef, useState } from "react";
import {LazyLoadImage} from 'react-lazy-load-image-component';
const VISUALIZE__URL = import.meta.env.VITE_VISUALIZE__URL;
import { useTranslation } from "react-i18next";

// image for other screens - potrait
const game_changer1 = VISUALIZE__URL + "game_changer_patient_health_concern_compress.webp";
const game_changer2 = VISUALIZE__URL + "game_changer_arrange_appointments_compress.webp";
const game_changer3 = VISUALIZE__URL + "game_changer_waiting_room_compress.webp";
const game_changer4 = VISUALIZE__URL + "game_changer_doctors_3d_animation_compress.webp";
const game_changer5 = VISUALIZE__URL + "game_changer_patient_trust_compress.webp";
const game_changer6 = VISUALIZE__URL + "game_changer_patient_satisfaction_compress.webp";

//image for mbl view - landscape
const game_changer_mbl1 = VISUALIZE__URL + "gamechange_mbl1.webp";
const game_changer_mbl2 = VISUALIZE__URL + "gamechange_mbl2.webp";
const game_changer_mbl3 = VISUALIZE__URL + "gamechange_mbl3.webp";
const game_changer_mbl4 = VISUALIZE__URL + "gamechange_mbl4.webp";
const game_changer_mbl5 = VISUALIZE__URL + "gamechange_mbl5.webp";
const game_changer_mbl6 = VISUALIZE__URL + "gamechange_mbl6.webp";

//arrow
const game_changer_arrow1 = VISUALIZE__URL + "arrow1.webp";
const game_changer_arrow2 = VISUALIZE__URL + "arrow2.webp";
const game_changer_arrow3 = VISUALIZE__URL + "arrow3.webp";
const game_changer_arrow4 = VISUALIZE__URL + "arrow4.webp";
const game_changer_arrow5 = VISUALIZE__URL + "arrow5.webp";



export default function WorkFlow() {
  const [selectedIndex, setSelectedIndex] = useState(0);
    const [carPosition, setCarPosition] = useState(10);
      const { t } = useTranslation();

  const imageRefs = useRef<Array<HTMLDivElement | null>>([]);
  const progressBarRef = useRef<HTMLDivElement | null>(null);

  const updateCarPosition = () => {
    if (imageRefs.current[selectedIndex] && progressBarRef.current) {
      const imageRect =
        imageRefs.current[selectedIndex]?.getBoundingClientRect();
      const barRect = progressBarRef.current.getBoundingClientRect();

      if (imageRect && barRect) {
        const imageCenterX = imageRect.left + imageRect.width / 2;
        const barLeft = barRect.left;
        const barWidth = barRect.width;
        const positionPercent = ((imageCenterX - barLeft) / barWidth) * 100;
        setCarPosition(Math.max(0, Math.min(100, positionPercent)));
      }
    }
  };

  useEffect(() => {
    updateCarPosition();
    window.addEventListener("resize", updateCarPosition);
    return () => window.removeEventListener("resize", updateCarPosition);
  }, [selectedIndex]);
    
  const gamechanger = [
    {
      id: 1,
      title: `<b>${t("booking")}</b>`,
      name: `${t("from_concern_to")} ${t("appointment")}`,
      image: game_changer1,
      image_mbl: game_changer_mbl1,
      image_arrow: game_changer_arrow1,
      color: "#1976d3",
      color1: "#1976d3",
    },
    {
      id: 2,
      title: `${t("pre_visit")}`,
      name: `${t("arrange_appointment")}`,
      image: game_changer2,
      image_mbl: game_changer_mbl2,
      image_arrow: game_changer_arrow2,
      color: "#1976d3",
      color1: "#1976d3",
    },
    {
      id: 3,
      title: `${t("during_visit")}`,
      name: `${t("informative_waiting_room_experience")}`,
      image: game_changer3,
      image_mbl: game_changer_mbl3,
      image_arrow: game_changer_arrow3,
      color: "#2f84d7",
      color1: "#2f84d7",
    },
    {
      id: 4,
      title: `${t("during_visit")}`,
      name: `${t("doctor_shares_3d_animation")}`,
      image: game_changer4,
      image_mbl: game_changer_mbl4,
      image_arrow: game_changer_arrow4,
      color: "#3083d8",
      color1: "#3083d8",
    },
    {
      id: 5,
      title: `${t("post_visit")}`,
      name: `${t("improved_understanding_patient_trust")}`,
      image: game_changer5,
      image_arrow: game_changer_arrow5,
      image_mbl: game_changer_mbl5,
      color: "#4791db",
      color1: "#4791db",
    },
    {
      id: 6,
      title: `${t("post_visit")}`,
      name: `${t("improved_patient_satisfaction_review_scores")}`,
      image: game_changer6,
      image_mbl: game_changer_mbl6,
      color: "#5398db",
      color1: "#ffffff",
    },
  ];


    return (
      <>
        <Box
          sx={{
            padding: { xs: "7% 2%", sm: "3% 5%" },
            animation: "fadeIn 1s ease-in-out 1s forwards",
            "@keyframes fadeIn": {
              from: { opacity: 0, transform: "translateY(20px)" },
              to: { opacity: 1, transform: "translateY(0)" },
            },
          }}
          className="section_1"
        >
          <Box
            className="ad_box2"
            sx={{
              width: "100%",
              display: "flex",
              padding: { xs: "7% 2%", sm: "3% 0%" },
            }}
          >
            <Grid container spacing={3} alignItems="center">
              {/* Left Typography */}
              <Grid item xs={12} md={8}>
                <Typography
                  fontWeight="bold"
                  color="#0080ff"
                  //   variant="h6"
                  lineHeight="1.2"
                  fontSize={{
                    xs: "22px",
                    sm: "22px",
                    md: "32px",
                    lg: "34px",
                  }}
                  sx={{
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                    maxWidth: "100%",
                    width: "100%",
                    px: { xs: 2, sm: 0 }, // Add horizontal padding on mobile
                  }}
                >
                  {t("accurate_visuals_educated_patients_better_reviews")}
                </Typography>
              </Grid>
            </Grid>
          </Box>
          <Box
            ref={progressBarRef}
            className="progressBar"
            sx={{
              width: "100%",
              display: { xs: "none", lg: "block" },
              height: "5px",
              backgroundColor: "#1976d2",
              position: "relative",
              mt: "50px",
              mb: 4,
              borderRadius: "5px",
            }}
          >
            <Box
              sx={{
                width: "170px", // width of the black segment under the car
                height: "100%",
                backgroundColor: "trasparent",
                position: "absolute",
                left: `${carPosition}%`,
                top: 0,
                transform: "translateX(-50%)",
                transition: "left 0.5s ease",
                zIndex: 1,
                borderRadius: "3px",
              }}
            />

            <Box
              sx={{
                width: "125px",
                height: "auto",
                position: "absolute",
                top: "-40px",
                left: `${carPosition}%`,
                transform: "translateX(-50%) scaleX(1) rotate(360deg)",
                transition: "left 0.5s ease",
              }}
            >
              <LazyLoadImage
                src={ecgWave}
                className="ecgWave"
                alt="Car Icon"
                effect="blur"
                width="100%"
              />
            </Box>
            {/* <Box
              component="img"
              src={ecgWave}
              className="ecgWave"
              alt="Car Icon"
              sx={{
                width: "125px",
                height: "auto",
                position: "absolute",
                top: "-40px",
                left: `${carPosition}%`,
                transform: "translateX(-50%) scaleX(1) rotate(360deg)",
                transition: "left 0.5s ease",
                // filter:
                //   "invert(24%) sepia(97%) saturate(7461%) hue-rotate(360deg) brightness(87%) contrast(75%)",
              }}
            /> */}
          </Box>

          <Stack
            useFlexGap
            flexWrap={"wrap"}
            className="waveContent"
            sx={{
              mt: { xs: "50px", xl: "60px" },
              display: "flex",
              flexDirection: "row",
              gap: { xs: "30px", sm: "50px" },
              flexWrap: { xs: "wrap", lg: "nowrap" },
              //   justifyContent: { xs: "center", xl: "space-between" },
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {gamechanger.map((member, index) => (
              <Box
                key={index}
                onClick={() => setSelectedIndex(index)}
                ref={(el) => {
                  imageRefs.current[index] = el as HTMLDivElement | null;
                }}
                onMouseEnter={() => setSelectedIndex(index)}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: { xs: "90%", md: "40%", lg: "100%" },
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    mt: 0,
                    mb: 2,
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: member.id === 1 ? 400 : 600,
                      width: { sm: "100%" },
                      height: {
                        sm: "25px",
                      },
                      lineHeight: { xs: 1.1, sm: 1.3 },
                      color: "#212121",
                      fontSize: {
                        xs: member.id === 1 ? 15 : 16,
                        sm: member.id === 1 ? 15 : 16,
                        lg: member.id === 1 ? 15 : 16,
                        xl: member.id === 1 ? 17 : 18,
                        xxl: member.id === 1 ? 18 : 20,
                      },

                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      textWrap: "wrap",
                    }}
                    dangerouslySetInnerHTML={{ __html: t(member.title) }}
                  />
                </Box>
                <Box
                  sx={{
                    display: "grid",
                    flexDirection: "column",
                    alignItems: "center",
                    borderRadius: "16px 35px 20px 16px",
                    width: "100%",
                    height: "100%",
                    overflow: "visible",
                    transition: "transform 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-8px)",
                    },
                    position: "relative",
                    background: "white",
                    borderLeft: "2px dashed #1976d2",
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 6,
                      width: "60%",
                      height: "2px",
                      borderTop: "2px dashed #1976d2",
                    }}
                  />
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      left: 7,
                      width: "60%",
                      borderBottom: "2px dashed #1976d2",
                    }}
                  />
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      width: "40%",
                      height: "100%",
                      backgroundColor: "#1976D2",
                      borderRadius: "0 16px 16px 0",
                      zIndex: 0,
                    }}
                  />
                  {member.image_arrow && (
                    <Box
                      component="img"
                      src={member.image_arrow}
                      alt="Arrow Icon"
                      loading="lazy"
                      className="ecgWaveArrowIcon"
                      width="24px" // Adjust size if needed
                      height="auto"
                      sx={{
                        position: "absolute",
                        right: { xs: "20%", sm: "-18px" }, // Center horizontally for mobile, right for larger screens
                        bottom: { xs: "-20px", sm: "auto" }, // Move below the box on mobile
                        top: { xs: "auto", sm: "50%" }, // Remove top positioning for mobile
                        transform: {
                          xs: "translateX(50%) rotate(90deg)",
                          sm: "translateY(-50%) rotate(0deg)",
                        },
                        //   width: "24px", // Adjust size if needed
                        //   height: "auto",
                        zIndex: 2,
                        color: member.color1,
                      }}
                    />
                  )}

                  <Box
                    sx={{
                      position: "absolute",
                      top: "-10px",
                      left: "-10px",
                      width: "45px",
                      height: "45px",
                      bgcolor: "#108bb7",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 2,
                    }}
                  >
                    <Typography
                      //   variant="h6"
                      sx={{
                        fontWeight: 600,
                        color: "white",
                        fontSize: "1.5rem",
                        position: "absolute",
                        top: "1px",
                        left: "12px",
                      }}
                    >
                      {member.id}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      padding: "12px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      height: {
                        md: "250px",
                        lg: "200px",
                        xl: "280px",
                      }, // Ensure equal height for all images
                      boxSizing: "border-box",
                      zIndex: 3,
                    }}
                  >
                    <Box
                      sx={{
                        display: { xs: "none", sm: "flex" },
                        width: "100%",
                        height: "100%",
                        borderRadius: "16px",
                        boxSizing: "border-box",
                        overflow: "hidden", //  Ensure the image follows borderRadius
                      }}
                    >
                      <Box
                        component="img"
                        src={member.image}
                        alt={t(member.name)}
                        loading="lazy"
                        width="100%"
                        height="100%"
                        sx={{
                          //   width: "100%",
                          //   height: "100%",
                          objectFit: "cover",
                          borderRadius: "16px",
                        }}
                      />
                    </Box>
                    <Box
                      sx={{
                        display: { xs: "flex", sm: "none" },
                        width: "100%",
                        height: "100%",
                        borderRadius: "16px",
                        boxSizing: "border-box",
                        overflow: "hidden",
                      }}
                    >
                      <Box
                        component="img"
                        src={member.image_mbl}
                        alt={t(member.name)}
                        loading="lazy"
                        width="100%"
                        height="100%"
                        sx={{
                          //   width: "100%",
                          //   height: "100%",
                          objectFit: "cover",
                          borderRadius: "16px",
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    mt: 3,
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      width: { sm: "90%" },
                      height: {
                        sm: "60px",
                      },
                      lineHeight: { xs: 1.1, sm: 1.3 },
                      color: "#333",
                      fontSize: {
                        xs: "15px",
                        sm: "15px",
                        lg: "15px",
                        xl: "17px",
                        xxl: "18px",
                      },
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      textWrap: "wrap",
                    }}
                    dangerouslySetInnerHTML={{ __html: t(member.name) }}
                  />
                </Box>
              </Box>
            ))}
          </Stack>
        </Box>
      </>
    );
}
